import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetGroupIdentityByIdRequest,
    GetGroupIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<GetGroupIdentityByIdResponse, GetGroupIdentityByIdResponse>,
) => response?.data?.groupIdentity;
const getError = (
    response?: SWRResponse<GetGroupIdentityByIdResponse, GetGroupIdentityByIdResponse>,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<GetGroupIdentityByIdResponse, GetGroupIdentityByIdResponse>,
) => ({});

const useGroupIdentityById = (
    id?: number | null | undefined,
    configuration?:
        | SWRConfiguration<GetGroupIdentityByIdResponse, GetGroupIdentityByIdResponse>
        | null
        | undefined,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetGroupIdentityByIdResponse> => new GetGroupIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useGroupIdentityById;
